import React from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import {emptyFn} from "presentation/common/helpers/utils";
import {Form, Formik} from "formik";
import * as Yup from "yup";
import {FormikInput, validateEmail} from "presentation/common";
import SendIcon from "../send-icon";
import {LoadingSpinnerIcon} from "presentation/common/components/style-guide/icons";

import styles from "./SignInForm.module.scss";

export const SignInForm = ({isLoading, onSubmit}) => {
  return (
    <div className={clsx('flex flex-col justify-center items-center mt-12 w-full px-3', styles.formContainer)}>
      <h3 className="mb-3">Bienvenido</h3>
      <h4>
        Ingrese su correo electrónico.
        <br/>
        Le enviaremos un enlace seguro para acceder.
      </h4>

      <div className={styles.signinForm}>
        <Formik
          initialValues={{email: ''}}
          validationSchema={
            Yup.object().shape({
              email: validateEmail("El correo electrónico es requerido."),
            })}
          onSubmit={onSubmit}>
          {
            (formik) => {
              return (
               <Form>
                 <div className={styles.inputContainer}>
                   <FormikInput name='email'/>
                   <div className={clsx(styles.sendIcon, {[styles.isSending]: isLoading})}>
                     {isLoading ? <LoadingSpinnerIcon/> : <button type="submit"><SendIcon/></button>}
                   </div>
                 </div>
               </Form>
              )
            }
          }
        </Formik>
      </div>
    </div>
  );
};

SignInForm.propTypes = {
  onSubmit: PropTypes.func
}

SignInForm.defaultProps = {
  onSubmit: emptyFn
}

export default React.memo(SignInForm);
